import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Actions_Wind from '~/Actions_Wind';
import Tree from '~/components/Tree';
import BCIF_Container from '../BCIF_Container';

const Original_Equity = ({ windId }) => {
  const dispatch = useDispatch();
  const BIPOEquity = useSelector(state => state.data.BIPOEquity || '[]');
  useEffect(() => {
    Actions_Wind.getBIPOEquity(dispatch, { windId });
    return () => Actions_Wind.clearKey(dispatch, { key: 'BIPOEquity' });
  }, []);
  let haveData = false;
  try {
    if (JSON.parse(BIPOEquity).length)haveData = true;
  } catch {}
  return (
    <BCIF_Container title='股權架構' defaultOpen={false}>
      {haveData && <Tree disabled data={BIPOEquity} />}
      {!haveData && <div style={{ margin: 20, fontSize: 20, textAlign: 'center' }}>(暫無資料)</div>}
    </BCIF_Container>
  );
};

export default Original_Equity;
